import { makeStyles } from '@material-ui/core/styles';

import { PAINS_WIDTH, PAINS_GAP, PAIN_HEIGHT } from '../../const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: PAINS_WIDTH,
      minHeight: PAIN_HEIGHT,
    },

    pain: {
      position: 'absolute',
      maxWidth: `calc((100% - ${PAINS_GAP}px) / 2)`,
      height: PAIN_HEIGHT,
    },
  }),
  { name: 'PersonaDetailsPanel' }
);
